import React from 'react';
import Img from '../../Img';
import useCollegeProspectAccess from '../../hooks/useCollegeProspectAccess';
import {
    CPP_UPGRADE_FEATURES,
    CPP_UPGRADE_OTHER_BENEFITS_FEATURE,
    CPP_UPGRADE_SUBTITLE,
} from '../../Profile/CollegeProspectTab/MyTargetColleges/components/UpgradeToAnnualBanner';
import styles from './cppUpgradeLeftColumn.scss';

const CppUpgradeLeftColumn = () => {
    const { isPowered } = useCollegeProspectAccess();
    // Free members see the extra Power-benefits bullet (matching the upgrade banner); Power Monthly
    // members upgrading to annual do not.
    const features = isPowered
        ? CPP_UPGRADE_FEATURES
        : [...CPP_UPGRADE_FEATURES, CPP_UPGRADE_OTHER_BENEFITS_FEATURE];

    return (
        <div className={styles.container}>
            <div className={styles.subtitle}>
                {CPP_UPGRADE_SUBTITLE}
            </div>
            <div className={styles.features}>
                {features.map((feature) => (
                    <div key={feature.key} className={styles.feature}>
                        <Img
                            src={feature.iconSrc}
                            alt={feature.title}
                            className={styles.featureIcon}
                        />
                        <div className={styles.featureText}>
                            <div className={styles.featureTitle}>{feature.title}</div>
                            <div className={styles.featureDescription}>{feature.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CppUpgradeLeftColumn;
